import { EMangoVopStatus } from "../types/contact.types";
import { getLocalizedText } from "./i18n/i18n.utils";
export var getMangoVopStatusInfo = function (status) {
    if (!status) {
        return null;
    }
    switch (status) {
        case EMangoVopStatus.Match:
            return {
                color: "#2e7d32",
                title: getLocalizedText("bank_account.mango_vop_status.match"),
            };
        case EMangoVopStatus.CloseMatch:
            return {
                color: "#ed6c02",
                title: getLocalizedText("bank_account.mango_vop_status.close_match"),
            };
        case EMangoVopStatus.NoMatch:
        case EMangoVopStatus.MatchNotPossible:
            return {
                color: "#d32f2f",
                title: getLocalizedText("bank_account.mango_vop_status.no_match"),
            };
        default:
            return null;
    }
};
